import React from "react";
import "../../scss/CustomerIndex.css"
import CreateObjectRowWithLabelComponent from "../../components/CreateObjectRowWithLabelComponent";

export default class AgentPersonalDetailsComponent extends React.Component {

    render() {

        let person = this.props.person;
        return <div>
            <div>
                <CreateObjectRowWithLabelComponent label={"Full Name"} className={"pull-left"}>
                    {person.firstName + " " + person.lastName}
                </CreateObjectRowWithLabelComponent>
            </div>
        </div>

    }
}
